import { render, staticRenderFns } from "./SamluserList.vue?vue&type=template&id=4ec936af&"
import script from "./SamluserList.vue?vue&type=script&lang=js&"
export * from "./SamluserList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports